// @flow
import React, { Fragment } from "react";
import { Box, Button, Control, Input } from "biologiatotal-ui";
import { Checkbox } from "../../../components/checkbox";
import "./registerForm.scss";
import Form from "../../../components/form";
import { Link } from "react-router-dom";

import formSchema from "./schema";

class RegisterForm extends Form {
  constructor(props: any) {
    super(props, formSchema);

    this.doRegister = this.doRegister.bind(this);
  }

  componentDidMount() {
    this.setState({
      values: {
        ...this.state.values,
        newsSubscriber: true
      }
    });
  }

  doRegister() {
    const { onRegister } = this.props;

    this.validate().then(
      () => onRegister({ ...this.getValues(), freeTrial: true }),
      () => null
    );
  }

  render() {
    const { showRegisterButton, isRegistering, className = "" } = this.props;
    const { values, errors } = this.state;

    return (
      <Fragment>
        <div className={`columns register-panel ${className}`}>
          <div className="column centered is-12-mobile is-8-tablet is-6-desktop is-4-widescreen is-offset-2-tablet is-offset-3-desktop is-offset-4-widescreen">
            <Box className="register-panel-content">
              <div className="register-panel-header">
                <span className="register-panel-title">BEM-VINDO</span>
                <span className="register-panel-subtitle">Faça seu cadastro para ter acesso à plataforma</span>
              </div>

              <Control className="register-panel-control">
                <span className="register-panel-label">Nome completo:</span>
                <Input
                  type="text"
                  danger={!!errors.name}
                  value={values.name}
                  onChange={e => this.update("name", e.target.value)}
                  placeholder="Nome Completo"
                  className="register-panel-input"
                />
                <p className="help is-danger register-panel-info">{errors.name}</p>
              </Control>
              <Control className="register-panel-control">
                <span className="register-panel-label">E-mail:</span>
                <Input
                  type="email"
                  value={values.email}
                  danger={!!errors.email}
                  onChange={e => this.update("email", e.target.value)}
                  placeholder="E-mail"
                  className="register-panel-input"
                />
                <p className="help is-danger register-panel-info">{errors.email}</p>
              </Control>
              <Control className="register-panel-control">
                <span className="register-panel-label">Confirme seu e-mail:</span>
                <Input
                  type="email"
                  value={values.emailConfirmation}
                  danger={!!errors.emailConfirmation}
                  onChange={e => this.update("emailConfirmation", e.target.value)}
                  placeholder="Confirme seu e-mail"
                  className="register-panel-input"
                />
                <p className="help is-danger register-panel-info">{errors.emailConfirmation}</p>
              </Control>
              <Control className="register-panel-control">
                <span className="register-panel-label">Senha:</span>
                <Input
                  value={values.password}
                  danger={!!errors.password}
                  placeholder="****"
                  onChange={e => this.update("password", e.target.value)}
                  type="password"
                  className="register-panel-input"
                />
                <div className="register-panel-password-label">
                  Sua senha deve ter pelo menos 8 caracteres contendo letras e números
                </div>
                <p className="help is-danger register-panel-info">{errors.password}</p>
              </Control>
              <Control className="register-panel-control">
                <span className="register-panel-label">Confirme a senha:</span>
                <Input
                  danger={!!errors.passwordConfirmation}
                  value={values.passwordConfirmation}
                  onChange={e => this.update("passwordConfirmation", e.target.value)}
                  placeholder="****"
                  type="password"
                  className="register-panel-input"
                />
                <p className="help is-danger register-panel-info">{errors.passwordConfirmation}</p>
              </Control>
              <Control className="register-panel-control">
                <Checkbox
                  ariaLabel="Aceito receber dicas de estudo e vantagens"
                  name="register-receive-news"
                  value={values.newsSubscriber}
                  onChange={value => this.update("newsSubscriber", value)}>
                  Aceito receber dicas de estudo e vantagens
                </Checkbox>
              </Control>
              <Control className="credit-card-control column is-12">
                <Checkbox
                  value={values.terms}
                  ariaLabel="Li e concordo com os termos de uso"
                  onChange={value => this.update("terms", value)}>
                  Li e concordo com os
                  <Link className="credit-card-terms" to="/termos-de-uso" target="_blank">
                    {" "}
                    Termos de Uso{" "}
                  </Link>
                  e com a
                  <Link className="credit-card-terms" to="/politica-de-privacidade" target="_blank">
                    {" "}
                    Política de Privacidade{" "}
                  </Link>
                </Checkbox>
                <p className="credit-card-info help is-danger">{errors.terms}</p>
              </Control>

              {showRegisterButton ? (
                <Button
                  loading={isRegistering}
                  gradientLink
                  large
                  className="register-panel-btn"
                  onClick={this.doRegister}>
                  ENTRAR
                </Button>
              ) : null}
            </Box>
          </div>
        </div>
      </Fragment>
    );
  }
}

RegisterForm.displayName = "RegisterForm";

export default RegisterForm;
